import React from 'react';
import styled from 'styled-components';
import { any, string, object } from 'prop-types';
import LinkCustom from '../../routes/Link';

const LinkContainer = styled.span`
    font-size: ${({ size = 11 }) => size}px;
    color: ${({ color = '#1fa02e' }) => color};
    background-color: transparent;
    cursor: ${({ cursor = 'pointer' }) => cursor};
    display: flex;
    flex: 1;
    justify-content: ${({ justify = 'flex-start' }) => justify};
    align-items: ${({ align = 'flex-start' }) => align};
    font-weight: ${({ bold, semibold }) => bold ? 'bold' : semibold ? 'semibold' : 'normal'};

    :hover {
        text-decoration: underline;
    }
`;

const Link = ({ children, text, style, src, ...props }) => (
    <LinkContainer style={style} {...props}>
        <LinkCustom href={src}>
            { children || text }
        </LinkCustom>
    </LinkContainer>
);

Link.propTypes = {
    children: any,
    text: string,
    style: object,
    src: string
};

Link.defaultProps = {
    src: '#'
};

export default Link;
